<template>
  <v-card flat color="transparent" outlined class="pa-4">
    <!-- Título + Acciones -->
    <v-row align="center" class="mb-4">
      <v-col cols="12" md="6">
        <h2 class="font-weight-bold mb-2">Gastos</h2>
      </v-col>
      <v-col cols="12" md="6" class="text-right">
        <v-btn
          @click="$router.push({ name: 'pos.egresos.gastos.nuevo' })"
          color="primary"
          >Nuevo gasto</v-btn
        >
      </v-col>
    </v-row>

    <v-divider class="my-2"></v-divider>

    <!-- Tabs -->
   

    <v-row>
      <v-col>
        <router-view  />
      </v-col>
    </v-row>

   
  </v-card>
</template>
  
  <script>


export default {
  name: "GastosSucursalHome",
  components: {
    
  },



 


};
</script>
  
  <style>

</style>
  